import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function Gate() {
  const { session } = useAuth();
  if (session === null) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-slate-400" />
      </div>
    );
  }
  if (!session) return <Navigate to="/login" replace />;
  if (session.impersonating) {
    const im = session.available_modules || [];
    if (im.includes("module_1")) return <Navigate to="/m1" replace />;
    return <Navigate to="/platform" replace />;
  }
  if (session.platform_role) return <Navigate to="/platform" replace />;

  const mods = session.available_modules || [];
  if (mods.length === 0) return <Navigate to="/billing" replace />;
  return <Navigate to="/m1" replace />;
}
